import React from 'react';
import { connect } from 'react-redux';
import { Table, Container, Row, Col, Input } from 'reactstrap';
import i18n from "../../../i18next";
import Pagination from 'react-js-pagination';

import { loadPromotionNames } from '../../../actions/restaurants/customerInsight/CustomerInsightAction'
import { loadRestaurantInsightPromoCodesSummarySearch } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import { getPriceWithCurrencySymbol, localizeDiscountType } from '../../../utils/CommonUtils';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from "../../../utils/Constants";
import AutoCompleteSearch from '../../central/autosearch/AutoCompleteSearch';
import CustomerInsightSearchOptions from '../customerInsightScreen/CustomerInsightSearchOptions';


class PromoCodesSummarySearch extends React.Component {

    state = {
        fromDate: '',
        toDate: '',
        page: 0,
        orderTypeId: '',
        paymentTypeId: '',
        discountTypeId: '',
        promotionName: '',
        promotionId: '',
        promoCodeName: ''
    }

    componentDidMount() {
        const { restaurantId } = this.props;
        this.props.loadPromotionNames(this.props.restaurantId)
        this.props.loadRestaurantInsightPromoCodesSummarySearch(this.state.page, restaurantId,
        this.state.fromDate, this.state.toDate, this.state.paymentTypeId, this.state.orderTypeId, 
        this.state.discountTypeId, this.state.promotionId, this.state.promotionName, this.state.promoCodeName);
    }

    changeState = (e, promotion) => {
        if (promotion) {
            this.setState({ promotionId: promotion.id, promotionName: promotion.name })
        } else {
            this.setState({ promotionId: '', promotionName: e.target.value })
        }
    }

    takeSearchOptionState = searchOptionState => {
        const { restaurantId } = this.props;
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate,
                page: 0
            }, () => this.props.loadRestaurantInsightPromoCodesSummarySearch(this.state.page, restaurantId,
                this.state.fromDate, this.state.toDate, this.state.paymentTypeId, this.state.orderTypeId, 
                this.state.discountTypeId, this.state.promotionId, this.state.promotionName, this.state.promoCodeName));
    }

    handlePageChange = pageNumber => {
        const { restaurantId } = this.props;
        this.setState({
            page: (pageNumber - 1)
        }, () => this.props.loadRestaurantInsightPromoCodesSummarySearch(this.state.page, restaurantId,
            this.state.fromDate, this.state.toDate, this.state.paymentTypeId, this.state.orderTypeId, 
            this.state.discountTypeId, this.state.promotionId, this.state.promotionName, this.state.promoCodeName));
    }

    renderProductSummaryTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '25px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.name')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.quantity')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.totalSpent')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:restaurantInsightScreen.promotionId')}</th>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:restaurantInsightScreen.promotionName')}</th>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:restaurantInsightScreen.discountType')}</th>
            </tr>
        )
        
    }

    renderTableContent = () => {
        if(this.props.restaurantInsightPromoCodesSummary) {
            return this.props.restaurantInsightPromoCodesSummary.content.map(item => {
                return this.renderSingleItem(item);
            })
        } 
    }

    renderSingleItem = item => {

        const { tableDetail, firstRow, textCenter, textRight } = styles;
        const currency = this.props.restaurant.currency;
        const localizedDiscountType = localizeDiscountType(item.discountType)
        
        return (
            <tr>
               {item.promoCode ? <td style={{ ...tableDetail }}>{item.promoCode}</td> : <td style={{ ...tableDetail, ...textCenter }}>-</td> }
                <td style={{ ...tableDetail, ...textCenter }}>{item.count}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.totalDiscount, currency)}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.promotionId}</td>
                <td style={{ ...tableDetail }}>{item.promotionName}</td>
                <td style={{ ...tableDetail }}>{localizedDiscountType}</td>
            </tr>
        ); 
    }

    // renderOrderSVGIcon = type => {
    //     switch (type) {
    //         case "Delivery": return <DeliverySVG width={16} height={16} fill={'#0288D1'} />;
    //         case "Collection": return <PickUpSVG width={16} height={16} fill={'#0288D1'} />
    //         case "Curbside": return <CurbsideSVG width={16} height={16} fill={'#0288D1'} />
    //         case "Dine In": return <InStoreSvg width={16} height={16} fill={'#0288D1'} />
    //         default: return null
    //     }
    // }

    // renderOrderTypeName = type => {
    //     switch (type) {
    //         case "Delivery": return i18n.t('screens:customerInsightScreen.Delivery');
    //         case "Collection": return i18n.t('screens:customerInsightScreen.Collection');
    //         case "Curbside": return i18n.t('screens:customerInsightScreen.Curbside');
    //         case "Dine In": return i18n.t('screens:customerInsightScreen.Dine In');
    //         default: return null
    //     }
    // }

    // renderPaymentSVGIcon = type => {
    //     switch (type) {
    //         case "Credit card": return <CardsSVG width={15} height={15} fill={'#0288D1'} />
    //         case "Cash": return <CashSVG width={15} height={15} fill={'#0288D1'} />
    //         case "Loyalty": return <LoyaltyIconSvg width={15} height={15} fill={'#0288D1'} />
    //         default: return null
    //     }
    // }

    // renderPaymentTypeName = type => {
    //     switch (type) {
    //         case "Credit card": return i18n.t('screens:customerInsightScreen.creditCard');
    //         case "Cash": return i18n.t('screens:customerInsightScreen.cash');
    //         case "Loyalty": return i18n.t('screens:customerInsightScreen.loyalty');
    //         default: return null
    //     }
    // }

    renderAdditionalSearchOptions = () => {

        return (
            <Container fluid>
                <Row>
                    {this.renderOrderTypeDropdown()}
                    {this.renderPaymentTypeDropdown()}
                    {this.renderDiscountTypeDropdown()}
                </Row>
                <Row style={{marginTop: '10px'}}>
                    {this.renderPromotionNameAutoselect()}
                    {this.renderPromoCodeNameInput()}
                </Row>
            </Container>
        );
    }

    renderPromoCodeNameInput = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="text"
                    name="promoCodeName"
                    id="promoCodeName"
                    placeholder={i18n.t('screens:restaurantInsightScreen.promoCodeName')}
                    onChange={(e) => this.setState({ promoCodeName: e.target.value })}
                    value={this.state.promoCodeName}
                />
            </ Col>
        );
    }

    renderOrderTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="orderTypeId"
                    id="orderTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectOrderType')}
                    value={this.state.orderTypeId}
                    onChange={(e) => this.setState({ orderTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectOrderType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.Delivery')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.Collection')}</option>
                    <option value='4'>{i18n.t('screens:customerInsightScreen.Curbside')}</option>
                    <option value='5'>{i18n.t(`screens:restaurantsMainContainer.instore`)}</option>
                </Input>
            </ Col>
        );
    }

    renderPaymentTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="paymentTypeId"
                    id="paymentTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectPaymentType')}
                    value={this.state.paymentTypeId}
                    onChange={(e) => this.setState({ paymentTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectPaymentType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.creditCard')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.cash')}</option>
                </Input>
            </ Col>
        );
    }

    renderDiscountTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0, paddingRight: 0 }} >
                <Input
                    type="select"
                    name="discountTypeId"
                    id="discountTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectDiscountType')}
                    value={this.state.discountTypeId}
                    onChange={(e) => this.setState({ discountTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectDiscountType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.priceDiscount')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.freeProduct')}</option>
                    <option value='3'>{i18n.t('screens:customerInsightScreen.comboDeal')}</option>
                    <option value='4'>{i18n.t('screens:customerInsightScreen.loyalty')}</option>
                    <option value='5'>{i18n.t('screens:customerInsightScreen.marketingAutomation')}</option>
                </Input>
            </ Col>
        );
    }

    renderPromotionNameAutoselect = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <AutoCompleteSearch
                    inputId='name'
                    inputName='name'
                    placeholder={i18n.t('screens:restaurantInsightScreen.promotionName')}
                    inputValue={this.state.promotionName}
                    inputStyle={{}}
                    changeState={this.changeState}
                    searchValues={this.props.customerInsightPromotionNames} />
            </ Col>
        );
    }

    renderPagination() {
        const { flexEnd } = styles;
      
        return (
            <Container>
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={this.props.restaurantInsightPromoCodesSummary && this.props.restaurantInsightPromoCodesSummary.number + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={this.props.restaurantInsightPromoCodesSummary && this.props.restaurantInsightPromoCodesSummary.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row>
            </Container>

        );
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="ProductSummary" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderAdditionalSearchOptions()}
                {this.renderProductSummaryTable()}
                {this.renderPagination()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightPromotionNames: state.customerInsightPromotionNames,
        restaurantInsightPromoCodesSummary: state.restaurantInsight.promoCodesSummary,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { 
    loadRestaurantInsightPromoCodesSummarySearch,
    loadPromotionNames })(PromoCodesSummarySearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    flexEnd: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/restaurantInsight/PromoCodesSummarySearch.js